// Public demonstration only. No repository, model or persistent state.
export const narrativeScenes = [
  { id: "question", label: "landing.narrative.question", duration: 3000 },
  { id: "facts", label: "landing.narrative.brief", duration: 3600 },
  { id: "inference", label: "layer.inference", duration: 4200 },
  { id: "choice", label: "landing.narrative.choice", duration: 3900 },
  { id: "follow-through", label: "landing.narrative.followThrough", shortLabel: "landing.narrative.review", duration: 6500 },
];
export const narrativeDuration = narrativeScenes.reduce((sum, scene) => sum + scene.duration, 0);
export const initialNarrativeState = { scene: 0, elapsed: 0, playing: true, choice: "other", manual: false };

export function narrativeReducer(state, action) {
  switch (action.type) {
    case "tick": {
      if (!state.playing) return state;
      let { scene, elapsed, choice } = state;
      let advanced = false;
      elapsed += Math.max(0, action.delta);
      while (elapsed >= narrativeScenes[scene].duration) {
        elapsed -= narrativeScenes[scene].duration;
        scene = (scene + 1) % narrativeScenes.length;
        advanced = true;
        if (scene === 0) choice = "other";
      }
      return { ...state, scene, elapsed, choice, manual: advanced ? false : state.manual };
    }
    case "toggle": return { ...state, playing: !state.playing };
    case "pause": return state.playing ? { ...state, playing: false } : state;
    case "scene": return { ...state, scene: Math.max(0, Math.min(4, action.scene)), elapsed: 0, playing: false, manual: true };
    case "choice": return { ...state, choice: action.choice, scene: 3, elapsed: 0, playing: false, manual: true };
    case "commit": return { ...state, scene: 4, elapsed: 0, playing: false, manual: true };
    default: return state;
  }
}

export function getNarrativeContent(ex, t) {
  return {
    question: ex.question,
    // Use original status and provenance; an assumption never becomes a fact.
    items: ["K2", "A1", "U1"].map((id) => ex.items.find((item) => item.id === id)),
    artifacts: ["landing.narrative.cash", "landing.narrative.market", "landing.narrative.operations"],
    recommendation: ex.options.find((option) => option.id === ex.brief.recommendation.optionId),
    because: ex.brief.recommendation.because,
    confidence: ex.brief.recommendation.confidence.toFixed(2),
    choices: {
      other: { option: ex.options.find((option) => option.id === ex.decision.optionId), rationale: ex.decision.rationale },
      // Prewritten human example; not copied or generated from the AI rationale.
      recommended: { option: ex.options.find((option) => option.id === ex.brief.recommendation.optionId), rationale: t("landing.narrative.followRationale") },
    },
    followThrough: ex.followThrough,
  };
}
